import styled from "styled-components/macro";

import { useHasSignupAdditionalNameRows } from "Boards/useHasSignupAdditionalNameRows";

import Portal from "Utilities/PortalMaker";
import { usePortalElement } from "Utilities/PortalMaker/usePortalElement";

export default function FiltersPanelAlert() {
  const portalToElement = usePortalElement("#filters_panel_alert_portal", 1000);
  const hasSignupAdditionalNameRows = useHasSignupAdditionalNameRows();

  if (!portalToElement) return null;
  if (!hasSignupAdditionalNameRows) return null;

  const getAlertContent = () => {
    if (hasSignupAdditionalNameRows) {
      return (
        <div>
          Guests are only included in filter results if their associated member
          matches the filter.
        </div>
      );
    }
  };

  return (
    <Portal to={portalToElement}>
      <Wrapper>{getAlertContent()}</Wrapper>
    </Portal>
  );
}

const Wrapper = styled.div`
  font-size: 13px;
  text-align: center;
  padding: 10px 14px 0;
`;
